import React, { useContext } from "react";

import { SiteContext } from "gatsby-frontend/src/Site";
import { Login, Public, Private } from "../";

import { Helmet } from "react-helmet";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { Page } from "gatsby-frontend";
import { getTheme } from "./../";

function SingleWrapper({ children }) {
	const { themeConfig } = useContext(SiteContext);
	const theme = getTheme(themeConfig);
	return (
		<ThemeProvider theme={theme.theme}>
			<Helmet>
				{theme.googleFonts && (
					<link rel="preconnect" href="https://fonts.googleapis.com" />
				)}
				{theme.googleFonts && (
					<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
				)}
				{theme.googleFonts && (
					<link
						href={`https://fonts.googleapis.com/css2?family=${theme.googleFonts}&display=swap`}
						rel="stylesheet"
					/>
				)}
				<link
					rel="stylesheet"
					href="https://fonts.googleapis.com/icon?family=Material+Icons"
				/>
			</Helmet>
			<CssBaseline />
			{/* Wrap everything inside main plugin's Page layout 
          which processes page data and makes it available in all components
          via SingleContext
      */}
			<Page LoginForm={Login} PublicLayout={Public} PrivateLayout={Private}>
				{children}
			</Page>
		</ThemeProvider>
	);
}

export default SingleWrapper;
